import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { MultilineCustomControlProps } from "../../Utils/Interfaces";
import { CONTROL_MARGIN } from "../../MuiThemes";
import { FormControl } from "@mui/material";
import { getHelperText, propertyHasErrors } from "./inputHelpers";
import { Maybe } from "../../sharedCode/avroGraphql";

export default function MultilineEditor(props: MultilineCustomControlProps): JSX.Element {
    const [localValue, setLocalValue] = useState<Maybe<string>>(props.initialValue ?? "");

    return (
        <FormControl fullWidth>
            <TextField
                margin={CONTROL_MARGIN}
                fullWidth
                multiline
                minRows={props.minRows}
                label={props.labelText}
                value={localValue ?? ""}
                onChange={(e) => {
                    handleOnChange(e.target.value);
                }}
                onBlur={(e) => {
                    handleOnBlur(e.target.value);
                }}
                inputProps={{ style: { textTransform: "uppercase" } }}
                error={propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                helperText={getHelperText(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
            />
        </FormControl>
    );

    function handleOnChange(value: string | null): void {
        setLocalValue(value);
    }

    function handleOnBlur(value: string | null): void {
        if (value !== props.initialValue) {
            props.mergeChanges(props.sourceId, { [props.sourceProperty]: value?.toLocaleUpperCase() });
        }
    }
}
